export default "__VITE_ASSET__bOTcAUvt__"